<h1 mat-dialog-title>
  Manage Message Templates
</h1>

<mat-dialog-content>

  @if (!newTemplate) {
    <div class="flex-row justify-content-space-between align-items-center mb-10 ml-16">
      <div>
        Create a new template
      </div>
      <button mat-stroked-button
              (click)="createTemplate()">
        New Template
      </button>
    </div>
  } @else {
    <div class="flex-column py-8">
      <app-message-template-editor [template]="newTemplate"
                                   [isNew]="true"
                                   class="px-16"
                                   (templateUpdated)="newTemplateSaved($event)"
                                   (templateDeleted)="newTemplateCanceled()"
      >
      </app-message-template-editor>
    </div>
  }

  @if (templates.length) {
    <mat-divider></mat-divider>
    <div class="flex-column py-8">
      @for (template of templates; track $index) {
        <app-message-template-editor [template]="template"
                      class="px-16"
                      (templateDeleted)="deleteTemplate($index)"
                      (templateUpdated)="updateTemplate($index, $event)"
        >
        </app-message-template-editor>
        @if (!$last) {
          <mat-divider></mat-divider>
        }
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>
    Cancel
  </button>
  <button mat-button
          [mat-dialog-close]="templates"
          cdkFocusInitial
  >
    Save and Close
  </button>
</mat-dialog-actions>
